import React, { useState } from "react";
import { MainBlockWithFewBannerBannersModel, MainPageModel } from "@admin/domain/uniquePages/models/MainPageModel";
import { v4 as uuid } from "uuid";
import { type UniquePageProps } from "../../index";
import Sortable from "@admin/components/Sortable";
import AddBannerModal from "../Common/AddBannerModal";
import { Language } from "@admin/domain/languages/helpers";
import Input from "@admin/components/Input";
import MultiLanguages from "@admin/components/MultiLanguage";
import JoditEditor from "@admin/components/JoditEditor";
import { FileModel } from "@admin/domain/files/model/FileModel";
import ImageInput from "@admin/components/ImageInput";

export default function MainPageMainBlockWithFewBanners({ page }: UniquePageProps<MainPageModel>) {
    const bannersInit = (page.contentObject.main_block_with_few_banner__banners || []).map((value) => {
        return { ...value, id: uuid() };
    });

    const [showModal, setShowModal] = useState(false);
    const [banners, setBanners] = useState(bannersInit);
    const [editableBanner, setEditableBanner] = useState<MainBlockWithFewBannerBannersModel | undefined>();

    const addBanner = (banner: MainBlockWithFewBannerBannersModel) => {
        setBanners((prev) => [...prev, banner]);
    };

    const editBanner = (editedBanner: MainBlockWithFewBannerBannersModel) => {
        setBanners((prev) =>
            prev.map((prevBanner) => {
                if (prevBanner.id === editedBanner.id) {
                    return editedBanner;
                }

                return prevBanner;
            }),
        );
    };

    return (
        <div className="border rounded p-5 my-8">
            <h4 className="mb-5">Основной блок со слайдером с двойными баннерами</h4>

            <div className="form-check form-switch mb-5">
                <input
                    className="form-check-input"
                    type="checkbox"
                    name={`content[main_block_with_few_banner__is_public]`}
                    defaultValue="1"
                    defaultChecked={page.contentObject.main_block_with_few_banner__is_public}
                />
                <label className="form-check-label">Скрыть / Показать</label>
            </div>
            <Sortable list={banners} setList={setBanners} className="row row-cols-auto">
                {banners.map((banner: MainBlockWithFewBannerBannersModel, index: number) => (
                    <div
                        key={banner.id}
                        className="mb-5"
                        style={{
                            width: `fit-content`,
                            height: `fit-content`,
                        }}
                    >
                        <div className="card border">
                            <ImageInput
                                label="Изображение"
                                name={`content[main_block_with_few_banner__banners][${index}][file_id]`}
                                onChange={(file: FileModel | null): void => editBanner({ ...banner, file })}
                                defaultValue={banner.file}
                                className={{ container: `p-5 pb-0`, image: `img-thumbnail` }}
                            />

                            <div className="card-body">
                                <div className="card-text mb-3">
                                    <MultiLanguages
                                        languageElement={(language: Language) => (
                                            <Input
                                                label="Заголовок"
                                                name={`content[main_block_with_few_banner__banners][${index}][title][${language}]`}
                                                defaultValue={banner.title[language]}
                                            />
                                        )}
                                    />

                                    <MultiLanguages
                                        languageElement={(language: Language) => (
                                            <JoditEditor
                                                label="Текст под заголовком"
                                                name={`content[main_block_with_few_banner__banners][${index}][description][${language}]`}
                                                initHtml={banner.description[language] || ``}
                                            />
                                        )}
                                    />

                                    <MultiLanguages
                                        languageElement={(language: Language) => (
                                            <Input
                                                label="Текст кнопки"
                                                name={`content[main_block_with_few_banner__banners][${index}][button_text][${language}]`}
                                                defaultValue={banner.button_text[language]}
                                            />
                                        )}
                                    />

                                    <Input
                                        label="Ссылка"
                                        name={`content[main_block_with_few_banner__banners][${index}][url]`}
                                        defaultValue={banner.url}
                                    />

                                    <MultiLanguages
                                        languageElement={(language: Language) => (
                                            <Input
                                                label="Тэг"
                                                name={`content[main_block_with_few_banner__banners][${index}][tag][${language}]`}
                                                defaultValue={banner.tag[language]}
                                            />
                                        )}
                                    />
                                </div>
                                <div>
                                    <a
                                        className="card-link text-danger"
                                        onClick={() => {
                                            setBanners((prev) => prev.filter((value) => value.id !== banner.id));
                                        }}
                                    >
                                        Удалить
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Sortable>
            <i
                className="bi bi-plus-square text-primary fs-2hx cursor-pointer ms-3 align-self-center"
                onClick={() => {
                    setEditableBanner(undefined);
                    setShowModal(true);
                }}
            />

            {showModal && (
                <AddBannerModal<MainBlockWithFewBannerBannersModel>
                    showModal={showModal}
                    closeModal={() => setShowModal(false)}
                    onSubmit={editableBanner ? editBanner : addBanner}
                    editableBanner={editableBanner}
                />
            )}
        </div>
    );
}
